module.exports = __webpack_public_path__ + "img/file-xlsx.9ac08761.svg";